import { Icon } from '@chakra-ui/react'

export const EducationIcon = () => (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            opacity="0.7"
            d="M60 103.999C93.1371 103.999 120 100.642 120 96.4996C120 92.3577 93.1371 89 60 89C26.8629 89 0 92.3577 0 96.4996C0 100.642 26.8629 103.999 60 103.999Z"
            fill="#EEEEEE"
        />
        <path
            opacity="0.4"
            d="M102.861 51.7505H18.1851L19.5538 92.5308C19.6278 94.2796 21.0335 95.6563 22.7351 95.6563H98.2735C100.012 95.6563 101.418 94.2796 101.455 92.5308L102.861 51.7505Z"
            fill="#C3C3C3"
        />
        <path
            d="M102.381 48.6143L101.793 66.1376L100.984 90.4036C100.911 92.194 99.5135 93.5654 97.8223 93.5654H22.7442C21.0161 93.5654 19.619 92.1559 19.5822 90.4036L18.7733 66.1376L18.1851 48.6143H102.381Z"
            fill="#EEEEEE"
            stroke="#C3C3C3"
            strokeMiterlimit="10"
            strokeLinejoin="round"
        />
        <path opacity="0.5" d="M102.861 48.6143L102.269 66.3856H18.7399L18.1851 48.6143H102.861Z" fill="#C3C3C3" />
        <path
            d="M72.5699 40.2513H48.4753C45.0172 40.2513 42.2285 36.8388 42.2285 32.6073V23.1434C42.2285 18.912 45.0172 15.4995 48.4753 15.4995H72.5699C76.0279 15.4995 78.8167 18.912 78.8167 23.1434V32.6073C78.8167 36.8388 76.0279 40.2513 72.5699 40.2513ZM48.4753 20.9595C47.5085 20.9595 46.6905 21.9604 46.6905 23.1434V32.6073C46.6905 33.7903 47.5085 34.7913 48.4753 34.7913H72.5699C73.5367 34.7913 74.3547 33.7903 74.3547 32.6073V23.1434C74.3547 21.9604 73.5367 20.9595 72.5699 20.9595H48.4753Z"
            fill="#C3C3C3"
            stroke="#B0B0B0"
            strokeMiterlimit="10"
            strokeLinejoin="round"
        />
        <path
            d="M102.224 63.2495H17.8056C15.51 63.2495 13.7698 61.1748 14.029 58.8313L16.917 33.3212C17.1021 31.7076 18.398 30.5166 19.9531 30.5166H100.039C101.595 30.5166 102.927 31.746 103.076 33.3212L105.964 58.8313C106.26 61.1748 104.52 63.2495 102.224 63.2495Z"
            fill="#EEEEEE"
            stroke="#C3C3C3"
            strokeMiterlimit="10"
            strokeLinejoin="round"
        />
        <path
            d="M40.3483 70.1098H32.1055C31.3562 70.1098 30.7567 69.5103 30.7567 68.761V60.5182C30.7567 59.7689 31.3562 59.1694 32.1055 59.1694H40.3483C41.0976 59.1694 41.6971 59.7689 41.6971 60.5182V68.761C41.6971 69.5103 41.0976 70.1098 40.3483 70.1098ZM33.4543 67.3747H38.9994V61.8296H33.4543V67.3747Z"
            fill="#C3C3C3"
            stroke="#ACACAC"
            strokeMiterlimit="10"
            strokeLinejoin="round"
        />
        <path
            d="M88.3785 70.1093H80.1357C79.3864 70.1093 78.7869 69.5098 78.7869 68.7605V60.5178C78.7869 59.7684 79.3864 59.1689 80.1357 59.1689H88.3785C89.1278 59.1689 89.7273 59.7684 89.7273 60.5178V68.7605C89.7273 69.5098 89.1278 70.1093 88.3785 70.1093ZM81.522 67.3742H87.0671V61.8291H81.522V67.3742Z"
            fill="#C3C3C3"
            stroke="#ACACAC"
            strokeMiterlimit="10"
            strokeLinejoin="round"
        />
    </svg>
)
